import Phaser from 'phaser';

import { generate } from '../rendering/ProceduralAtlas.js';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    // Generate all game-entity textures procedurally from Canvas 2D.
    // No PNG/JSON assets are loaded from disk — textures are baked here
    // before the first game scene starts.
    //
    // try/catch: on iOS Safari under memory pressure, or on devices
    // that hit the browser's canvas-area cap, `scene.textures.createCanvas`
    // can return null and the atlas helpers throw. Without the catch,
    // the throw kills BootScene mid-create and the game soft-locks on a
    // black canvas — the worst signature for the CrazyGames Conversion
    // KPI (no sdkGameLoadingStop ever fires, portal stays stuck on its
    // loading overlay). We log and still start the menu; missing
    // textures show up as Phaser's magenta fallback but the game is
    // navigable and the player can at least reach the main menu.
    try {
      generate(this);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[boot] procedural atlas generation failed', err);
    }
    this.scene.start('MainMenu');
  }
}
